/**
 * Reusable blue banner header used at the top of every authenticated
 * content page (Piano di Cura, Feedback, Matching, etc., excluding
 * Monitor). Title + subtitle are bottom-aligned so they sit close to
 * the bottom edge of the banner. Optional `actions` slot renders
 * top-right (icon-only buttons by convention).
 *
 * Banner height is uniform across all pages. The `flat` flag only
 * controls whether the bottom blue overlap rectangle is rendered
 * (used to tuck a white card with `-mt-8` underneath the banner).
 */
const BANNER_BG = "#1a1fa8";

export default function PageHeader({ title, subtitle, actions, flat = false }) {
  return (
    <div className="relative mt-4 sm:mt-8">
      <div
        className="rounded-3xl px-6 sm:px-10 py-10 sm:py-14 pb-16 sm:pb-20 flex items-start justify-between gap-3"
        style={{ backgroundColor: BANNER_BG }}
      >
        <div>
          <h1 className="font-mono-menu text-2xl sm:text-3xl font-semibold tracking-tight text-white mb-2">
            {title}
          </h1>
          {subtitle && (
            <p className="text-white/70 text-sm sm:text-base">{subtitle}</p>
          )}
        </div>
        {actions && (
          <div className="flex flex-row items-center gap-2 flex-shrink-0 self-start">
            {actions}
          </div>
        )}
      </div>
      {!flat && (
        /* Blue fill behind white form corners */
        <div
          className="absolute bottom-0 left-0 right-0 h-12"
          style={{ backgroundColor: BANNER_BG, borderRadius: 0 }}
        />
      )}
    </div>
  );
}
